import {
  Briefcase,
  Building,
  ChevronDown,
  Home,
  LogIn,
  Plane,
  Settings,
  ShoppingBag,
  ShoppingCart,
  X,
} from "lucide-react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { handleLoginPopup } from "../redux/slice/userSlice";

const MobileDrawer = ({ isOpen, setIsOpen, navItems }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const dispatch = useDispatch();

  const getIcon = (name) => {
    switch (name) {
      case "Home":
        return Home;
      case "Marketplace":
        return ShoppingBag;
      case "Training":
        return Plane;
      case "Careers":
        return Briefcase;
      case "DSK":
        return Building;
      case "Drone City":
        return Map;
      case "Services":
        return Settings;
      default:
        return ShoppingCart;
    }
  };

  return (
    <div
      className={`fixed inset-0 z-50 md:hidden ${
        isOpen
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Overlay */}
      <div
        className={`absolute inset-0 bg-black/40 transition-opacity ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
        onClick={() => setIsOpen(false)}
      />

      {/* Drawer (RIGHT SIDE) */}
      <div
        className={`absolute top-0 right-0 h-full w-[85%] max-w-[320px] bg-white transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <span className="font-semibold text-[#003580]">Menu</span>
          <button
            onClick={() => setIsOpen(false)}
            className="p-2 rounded-md hover:bg-gray-100 transition"
          >
            <X size={18} />
          </button>
        </div>

        {/* Menu Items */}
        <div>
          {navItems.map((item, index) => {
            const Icon = getIcon(item.name);

            return (
              <div key={index}>
                {/* Dropdown */}
                {item.dropdown ? (
                  <>
                    <button
                      onClick={() =>
                        setOpenIndex(openIndex === index ? null : index)
                      }
                      className="flex items-center justify-between w-full px-4 py-3 text-sm border-b border-gray-200 hover:bg-gray-50"
                    >
                      <div className="flex items-center gap-3 text-[#003580]">
                        <Icon size={18} />
                        <span>{item.name}</span>
                      </div>

                      <ChevronDown
                        size={16}
                        className={`transition-transform ${
                          openIndex === index ? "rotate-180" : ""
                        }`}
                      />
                    </button>

                    {/* Submenu */}
                    {openIndex === index && (
                      <div className="bg-gray-50">
                        {item.dropdown.map((subItem, i) => (
                          <Link
                            key={i}
                            to={subItem.path}
                            onClick={() => setIsOpen(false)}
                            className="block px-10 py-2 text-sm text-gray-600 hover:bg-gray-100"
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 text-sm border-b border-gray-200 text-[#003580] ${
                      index === 0
                        ? "bg-gray-100 font-medium"
                        : "hover:bg-gray-50"
                    }`}
                  >
                    <Icon size={18} />
                    <span>{item.name}</span>
                  </Link>
                )}
              </div>
            );
          })}
        </div>

        {/* Bottom Buttons */}
        <div className="absolute bottom-0 left-0 w-full p-4 border-t border-gray-200 bg-white space-y-3">
          <button
            onClick={() => {
              setIsOpen(false); // ✅ close drawer
              dispatch(handleLoginPopup(true)); // ✅ open modal
            }}
            className="w-full flex items-center justify-center gap-2 bg-[#2b6cb0] text-white py-2 rounded-md shadow"
          >
            <LogIn size={16} />
            Log In
          </button>

          <button className="w-full border border-[#2b6cb0] text-[#2b6cb0] py-2 rounded-md">
            Partner Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileDrawer;
